module.exports = __webpack_public_path__ + "static/media/add-user.9dac36e2.svg";